<app-feature-editor title="Cutting Planes" [getItems]="getCuttingPlanes" [addItem]="addCuttingPlane" [deleteItem]="deleteCuttingPlane" (selectedIdChange)="cuttingPlaneIdChanged($event)">
  <div *ngIf="hasCuttingPlane" class="table">
    <div class="row">
      <div class="label-cell">Position</div>
      <div class="control-cell">
        <div class="pos-top-row">
          <input #relPosSlider type="range" min="0" max="1000" step="1" [value]="relativePosition * 1000" (input)="relativePositionChanged(relPosSlider.value)" />
          <button [class]="pickButtonClass" (click)="togglePick()">Pick</button>
        </div>
        <input #posInput type="text" [value]="positionString" (change)="positionStringChanged(posInput.value)" />
      </div>
    </div>
    <div class="spacer"></div>
    <div class="row">
      <div class="label-cell">Normal</div>
      <div class="control-cell">
        <div class="normal-buttons">
          <button (click)="normalChanged(1, 0, 0)">X</button>
          <button (click)="normalChanged(0, 1, 0)">Y</button>
          <button (click)="normalChanged(0, 0, 1)">Z</button>
          <button (click)="normalChanged(-normal.x, -normal.y, -normal.z)">Inv</button>
        </div>
        <input #normalInput type="text" [value]="normalString" (change)="normalStringChanged(normalInput.value)" />
      </div>
    </div>
    <div class="spacer"></div>
    <div class="row">
      <div class="label-cell">Map scalar</div>
      <div class="control-cell">
        <select #scalarResultSelect [value]="mapScalarResultId" (change)="mapScalarResultIdChanged(scalarResultSelect.value)">
          <option *ngFor="let item of scalarResults" [value]="item.id">{{item.name}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Map vector</div>
      <div class="control-cell">
        <select #vectorResultSelect [value]="mapVectorResultId" (change)="mapVectorResultIdChanged(vectorResultSelect.value)">
          <option *ngFor="let item of vectorResults" [value]="item.id">{{item.name}}</option>
        </select>
      </div>
    </div>
    <div class="row" *ngIf="showVectorGridSpacing">
      <div class="label-cell">Grid spacing</div>
      <div class="control-cell">
        <app-slider-textbox #spacingControl [value]="vectorGridSpacing" [min]="0.001" [max]="0.1" [precision]="3" (change)="vectorGridSpacingChanged(spacingControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Opacity</div>
      <div class="control-cell">
        <app-slider-textbox #opacityControl [value]="opacity" (change)="opacityChanged(opacityControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Clip</div>
      <div class="control-cell"><input #clippingCheckbox type="checkbox" [checked]="clipping" (change)="clippingChanged(clippingCheckbox.checked)"
        /></div>
    </div>
  </div>
</app-feature-editor>
